import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Body from "./components/Body";
import Navbar from "./components/Navbar";
import Login from "./components/Login";
import Bokning from "./components/Bokning";
import "./App.css";
import HomePage from "./components/HomePage";
import OmPage from "./components/omPage";
import AdminPage from "./components/AdminPage";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";

function App() {
  const [user, setUser] = useState([]);
  const [items, setItems] = useState([]);
  const [items2, setItems2] = useState([]);
  const [pictureList, setpictureList] = useState([]);
  const [showOverlay, setShowOverlay] = useState(true);
  const location = useLocation();

  function handleUser(user) {
    return setUser(user);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getList2();
    handleUser();
    getFolder();
  }, []);

  useEffect(() => {
    setShowOverlay(true);
    if (location.pathname !== "/admin" && location.pathname !== "/login") {
      axios.post("https://ellinornielsen-backend.onrender.com/api/visitors").catch(() => {});
    }
  }, [location.pathname]);

  async function getFolder() {
    const { data } = await axios.get(
      "https://ellinornielsen-backend.onrender.com/api/uploads"
    );
    setpictureList(data);
  }

  //Fetching items adding posters to videos to fix Safari black screen
  useEffect(() => {
    async function fetchItems() {
      const { data } = await axios.get(
        "https://ellinornielsen-backend.onrender.com/api/order"
      );

      const modifiedItems = data[0].image.map(async (img) => {
        if (img.mimetype === "video/mp4") {
          const videoElement = document.createElement("video");
          videoElement.crossOrigin = "anonymous";

          videoElement.src = `https://ellinornielsen-backend.onrender.com/api/uploads/${img.filename}`;
          videoElement.load();

          await new Promise((resolve) => {
            videoElement.onloadeddata = () => {
              console.log("Video loaded successfully");

              videoElement.currentTime = 0;

              videoElement.onseeked = () => {
                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");
                canvas.width = videoElement.videoWidth;
                canvas.height = videoElement.videoHeight;
                context.drawImage(
                  videoElement,
                  0,
                  0,
                  canvas.width,
                  canvas.height
                );
                const poster = canvas.toDataURL();
                img.poster = poster;
                resolve();
              };
            };
          });

          return img;
        }
        return img;
      });

      const updatedItems = await Promise.all(modifiedItems);
      console.log(updatedItems);
      setItems(updatedItems);
    }

    fetchItems();
  }, []);

  async function getList2() {
    const { data } = await axios.get(
      "https://ellinornielsen-backend.onrender.com/api/ordersecond"
    );
    setItems2(data[0].image);
  }

  const updateItems = (newItems) => {
    setItems([newItems]);
  };

  function correctName(path) {
    const name = path.replace("/", "");
    switch (name) {
      case "spelningar":
        return "Lyssna";
      case "bokning":
        return "Bokning";
      case "om":
        return "Om\u00A0\u00A0mig";
      case "login":
        return "Logga In";
      default:
        return "Ellinor\u00A0\u00A0Nielsen";
    }
  }

  function getRootName() {
    switch (location.pathname) {
      case "/brollop":
        return "brollop";
      case "/begravning":
        return "begravning";
      case "/dop":
        return "dop";
      case "/ovrigt":
        return "ovrigt";
      default:
        return "home";
    }
  }

  useEffect(() => {
    const root = document.documentElement;
    root.className = "";
    root.classList.add(getRootName());
  }, [location.pathname]);

  useEffect(() => {
    if (showOverlay) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showOverlay]);

  const curtainEase = [0.76, 0, 0.24, 1];
  const curtainDuration = 1.0;
  const curtainTimes = [0, 0.38, 0.62, 1];

  return (
    <AnimatePresence mode="sync">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.35 } }}
        exit={{ opacity: 0, transition: { duration: 0 } }}
      >
        {showOverlay && (
          <div
            key={location.pathname + "-overlay"}
            style={{ position: "fixed", inset: 0, zIndex: 1000, pointerEvents: "all" }}
          >
            {/* Left curtain */}
            <motion.div
              initial={{ x: "-100%" }}
              animate={{
                x: ["-100%", "0%", "0%", "-100%"],
                transition: { duration: curtainDuration, times: curtainTimes, ease: curtainEase },
              }}
              style={{
                position: "absolute", top: 0, left: 0,
                width: "50%", height: "100%",
                backgroundColor: "#ffffff",
              }}
            />
            {/* Right curtain */}
            <motion.div
              initial={{ x: "100%" }}
              animate={{
                x: ["100%", "0%", "0%", "100%"],
                transition: { duration: curtainDuration, times: curtainTimes, ease: curtainEase },
              }}
              onAnimationComplete={() => setShowOverlay(false)}
              style={{
                position: "absolute", top: 0, right: 0,
                width: "50%", height: "100%",
                backgroundColor: "#ffffff",
              }}
            />
            {/* Page name */}
            <motion.span
              initial={{ opacity: 0, letterSpacing: "0.6em" }}
              animate={{
                opacity: [0, 1, 1, 0],
                letterSpacing: ["0.6em", "0.06em", "0.06em", "0.6em"],
                transition: { duration: curtainDuration, times: [0.12, 0.4, 0.6, 0.88] },
              }}
              style={{
                position: "absolute", top: "50%", left: "50%",
                transform: "translate(-50%, -58%)",
                color: "#815641",
                fontFamily: "Great Vibes",
                fontStyle: "italic",
                fontSize: "clamp(44px, 9vw, 110px)",
                whiteSpace: "nowrap",
                zIndex: 1,
                pointerEvents: "none",
              }}
            >
              {correctName(location.pathname)}
            </motion.span>
            {/* Decorative line */}
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{
                scaleX: [0, 1, 1, 0],
                transition: { duration: curtainDuration, times: [0.32, 0.46, 0.6, 0.72], ease: "easeInOut" },
              }}
              style={{
                position: "absolute", top: "calc(50% + 34px)", left: "50%",
                translateX: "-50%",
                width: "clamp(120px, 20vw, 260px)", height: "1px",
                backgroundColor: "#c4a882",
                transformOrigin: "center",
                zIndex: 1,
              }}
            />
          </div>
        )}
        <div className="App">
          <StyledNav>
            <Navbar actuallUser={user} className="Navbar" />
          </StyledNav>
          <Routes location={location}>
            <Route path="/login" element={<Login />} />
            <Route path="/bokning" element={<Bokning />} />
            <Route
              path="/spelningar"
              element={
                <Body
                  itemsProp={items}
                  items2Prop={items2}
                  updateItems={updateItems}
                  showOverlay={showOverlay}
                />
              }
            />
            <Route path="/" element={<HomePage handleUser={handleUser} />} />
            <Route path="/om" element={<OmPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

export default App;

const StyledNav = styled.div`
  margin-bottom: 150px;
`;